import React from 'react';
import { TextArea } from 'semantic-ui-react';
import { gEnums } from '../../../enums/globalEnums';
import { uniqueKey } from '../../../common/keys';
import { TextAreaToggle } from './TextAreaToggle';

const TextAreaInput = (props) => {
  const { prop, fip, handleEditor, formItemType } = props
  const { key, label, propname } = fip ?? {}

  delete fip.key

  let rows = 5
  switch (propname) {
    case 'aboutMe':
    case 'bio':
    case 'note':
      rows = 20
      break;
    default:
      break;
  }
  switch (formItemType) {
    case gEnums.formItemTypes.textArea:
      return <TextAreaToggle fip={fip} handleEditor={handleEditor} rows={rows} prop={prop} />
    case gEnums.formItemTypes.textAreaSimple:
      return <React.Fragment>
        <div className='field'><label style={{ float: 'left' }}>{label}</label></div>
        <TextArea key={uniqueKey('ta', key)} {...fip} rows={rows} />
      </React.Fragment>
    default:
      return <React.Fragment>
        <div className='field'><label style={{ float: 'left' }}>{label}</label></div>
        <TextArea key={uniqueKey('ta', key)} {...fip} rows={rows} />
      </React.Fragment>
  }
}

export default TextAreaInput